import {registerDashboard} from "../../../../common/utils";
import SalesOperationsDashboardSrcAggregated from "../index";
import {raSurplusDashboardDefinition} from "../dashboardDefinition";


registerDashboard(raSurplusDashboardDefinition);  // This is a function that registers the dashboard definition to the dashboard list
// this will allow the dashboard to be managed by permission management.


export default function SurplusSrcAggregated({ title = "Sales Dashboard", defaultTab = 'sales' }) {
    return <SalesOperationsDashboardSrcAggregated title={title} defaultTab={defaultTab} dashboardDefinition={raSurplusDashboardDefinition}/>
}